import { useAuthStore } from '../store'
import { useGoLogin } from './useGoLogin'

/*
 * 访客模式的两个【组件】：GuestPrompt（登录引导块）、AmountDisplay（金额脱敏）。
 * 同名的两个 hook（useGuestAmount / useAuthRequired）在 useGuestHooks.jsx ——
 * 组件与非组件分文件放，否则 react-refresh 会失效。
 */

/**
 * 访客提示组件 - 显示在敏感数据区域
 */
export function GuestPrompt({ message = '登录后查看详细数据', className = '' }) {
  const goLogin = useGoLogin()
  const { isGuest, isAuthenticated } = useAuthStore()

  if (!isGuest && isAuthenticated) {
    return null
  }

  return (
    <div className={`bg-blue-50 border border-blue-200 rounded-lg p-4 text-center ${className}`}>
      <p className="text-blue-600 mb-2">{message}</p>
      <button
        onClick={goLogin}
        className="px-4 py-2 bg-primary-600 text-white text-sm rounded hover:bg-primary-700 transition-colors"
      >
        立即登录
      </button>
    </div>
  )
}

/**
 * 金额显示组件 - 自动处理访客模式
 */
export function AmountDisplay({ 
  amount, 
  className = '', 
  showLoginPrompt = false,
  prefix = '¥',
  suffix = ''
}) {
  const { isGuest, isAuthenticated } = useAuthStore()
  const goLogin = useGoLogin()

  const isGuestMode = isGuest || !isAuthenticated

  if (isGuestMode) {
    return (
      <span
        className={`${className} ${showLoginPrompt ? 'cursor-pointer hover:text-primary-600' : ''}`}
        onClick={showLoginPrompt ? goLogin : undefined}
        title={showLoginPrompt ? '点击登录查看' : '访客模式'}
      >
        {prefix}---.--{suffix}
      </span>
    )
  }
  
  const displayAmount = typeof amount === 'number' ? amount.toFixed(2) : amount
  
  return (
    <span className={className}>
      {prefix}{displayAmount}{suffix}
    </span>
  )
}
